module.exports = __webpack_public_path__ + "static/img/coop_travel.7a0c66e8.png";